import {CursorBasedPaginationResponse, QueryBaseTypeWithCursorPaginationWhereAndOrder} from 'api/common';
import {ItemDataFieldModel} from 'models/board';
import {SettingCreateUpdateRequest} from 'models/settings';

export interface MarketPlaceResponseModel {
    id: string;
    title: string;
    uniqueId: string;
    tags?: string;
    order: number;
    status: string;
    servers?: MarketPlaceServers[];
    data: ItemDataFieldModel[];
    icon: string;
    shortDescription: string;
    controlType: string;
    descriptionPageHtml: string;
    imageLibrary?: string[];
    publisher?: MarketPlacePublishedInfo;
    isMulti?: boolean;
    groupName?: string;
    includedIntegrationsCount: number;
    isInstalled?: boolean;
}

export interface MarketPlacePublishedInfo {
    title: string;
    icon?: string;
    details?: string;
    websiteUrl?: string;
}

export interface MarketPlaceServers {
    id: string;
    isDefault: boolean;
    url: string;
    title?: string;
}

// Additional types for API integration
export interface MarketPlaceListingRequest
    extends QueryBaseTypeWithCursorPaginationWhereAndOrder<MarketPlaceResponseModel> {}
export interface MarkPlaceListingResponse extends Omit<MarketPlaceResponseModel, 'data' | 'servers'> {}
export interface MarketPlacePaginationResponse {
    allMarketPlaces: CursorBasedPaginationResponse<MarkPlaceListingResponse>;
}
export const marketPlaceToSettingParser = (
    value: MarketPlaceResponseModel,
    objectType: string,
    objectId: string,
): SettingCreateUpdateRequest => {
    return {
        tenantId: objectId,
        title: value.title,
        uniqueId: value.uniqueId,
        order: value.order,
        data: value.data,
        controlType: value.controlType,
        isMulti: value.isMulti,
        objectId: objectId,
        objectType: objectType,
        marketPlaceId: value.id,
        groupName: value.groupName,
        servers: value.servers ? JSON.stringify(value.servers) : undefined,
    };
};
